import { appendIf } from '@btime/helpers'
import { assoc, compose, pick } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { formatApiDate } from '../../../../utils/helpers/date'
import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { useServiceOrder } from '../_load/ServiceOrderLoader'

const MUTATION = gql`
  mutation UpsertServiceOrder($input: ServiceOrderInput) {
    upsertServiceOrder(input: $input) {
      id
    }
  }
`

const cleanRequest = (form, serviceOrder) =>
  compose(
    item => pick(['id', 'groupId', 'userGroupIds', 'userId', 'events'], item),
    item => assoc('userId', item.userOrGroup?.__typename === 'User' ? item.userOrGroup?.id : null, item),
    item =>
      assoc(
        'groupId',
        item.userOrGroup?.__typename === 'UserGroup' && !Array.isArray(item.userOrGroup) ? item.userOrGroup?.id : null,
        item
      ),
    item =>
      assoc(
        'userGroupIds',
        Array.isArray(item.userOrGroup) && item?.userOrGroup?.every(group => group?.__typename === 'UserGroup')
          ? item.userOrGroup.map(group => group.id)
          : null,
        item
      ),
    item =>
      serviceOrder.status?.name === 'refused'
        ? assoc('events', [{ statusId: 1, eventDate: formatApiDate(new Date()) }], item)
        : item
  )(form)

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(Array.isArray(form.userOrGroup) ? !form.userOrGroup.length : !form.userOrGroup?.id, {
      path: ['userOrGroup'],
      message: 'Campo obrigatório'
    })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveServiceOrder = () => {
  const serviceOrder = useServiceOrder()
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['ServiceOrders', 'ServiceOrder'],
    client: serviceOrdersClient
  })

  const handleRequest = (form, actions, params = {}) => {
    const input = cleanRequest(form, serviceOrder)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
          if (!!params?.onSuccess) params.onSuccess(resp?.data?.upsertServiceOrder)
        }
      })
    }
  }

  return [handleRequest, state]
}
